export default __webpack_public_path__ + "static/media/ethereum-name-service-ens-logo.e800c247.svg";